import styled, { css } from 'styled-components'

import { SubscriptionContainer as Container } from 'common-styles'
import {
  Color,
  ExtraSubscriptionUIStatus,
  SubscriptionUIStatus,
  TExtendedSubscriptionUIStatus,
} from 'root-constants'

const getStatusColor = (status: TExtendedSubscriptionUIStatus) => {
  switch (status) {
    case SubscriptionUIStatus.CANCELED:
    case SubscriptionUIStatus.WITHDRAWN:
    case ExtraSubscriptionUIStatus.NOT_ACTIVE:
      return '#EB3B26'
    case SubscriptionUIStatus.ACTIVE:
    case SubscriptionUIStatus.TRIAL:
      return '#50AB64'
    case SubscriptionUIStatus.PAUSED:
      return '#FFA337'
    default:
      return Color.BLACK
  }
}

export const StyledSubscriptions = {
  DetailedSubscriptionsWrapper: styled.div`
    & div:not(:last-of-type) {
      margin-bottom: 16px;
    }
  `,
  SubscriptionRow: styled.div<{ withoutBottomOffset?: boolean }>`
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: ${Color.BLACK};
    font-weight: 400;
    line-height: 22px;
    ${({ withoutBottomOffset }) =>
      !withoutBottomOffset &&
      css`
        margin-bottom: 16px;
      `}
    & > span:first-of-type {
      max-width: 173px;
    }
  `,
  UnsubscribeInfo: styled.p`
    padding-top: 16px;
    border-top: 1px solid ${Color.GRAY_30};
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  `,
  WithdrawalDisclaimer: styled.p`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: ${Color.BLACK};

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  `,
  Separator: styled.div`
    width: 100%;
    height: 1px;
    background: ${Color.GRAY_20};
    margin-bottom: 16px;
  `,
  Status: styled(Container.InfoValue).attrs<{
    status: TExtendedSubscriptionUIStatus
  }>(({ status }) => ({ 'data-status': status }))<{
    status: TExtendedSubscriptionUIStatus
  }>`
    color: ${({ status }) => getStatusColor(status)};
    text-align: end;
  `,
  GiftHeadingRow: styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    color: ${Color.BLACK};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
  `,
  GiftIcon: styled.img`
    width: 18px;
    height: 18px;
  `,
  GiftSubtitle: styled.p`
    margin-top: 8px;
    color: ${Color.BLACK};
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
  `,
  GiftImage: styled.img`
    display: block;
    width: 193px;
    height: 193px;
    margin: 16px auto 0;
    object-fit: cover;
  `,
  DownloadButton: styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: 100%;
    margin-top: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${Color.BLACK};
    font-size: 17px;
    font-weight: 700;
    line-height: 24px;
    text-decoration: underline;
  `,
  DownloadIcon: styled.img`
    width: 24px;
    height: 24px;
  `,
}
